// extracted by mini-css-extract-plugin
export default {"hamburgerButton":"hamburgerButton-KBmBx","arrowIcon":"arrowIcon-QC7gA","arrowIconRight":"arrowIconRight-dJHzn","arrowIconLeft":"arrowIconLeft-LJZJU","menu":"menu-YBHMk"};